import { render, staticRenderFns } from "./tn-list.vue?vue&type=template&id=34328804&"
import script from "./tn-list.vue?vue&type=script&lang=js&"
export * from "./tn-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports